import React from "react";
import Select from "react-select";
import CustomizedOption from "./CustomizedOption";
import CustomizedCheckboxOption from "./CustomizedCheckboxOption";

class Table extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sort: props.sort,
      selectedItems: props.settings.selectedItems,
    };
    this.makeCheckbox = this.makeCheckbox.bind(this);
  }

  makeCheckbox(key) {
    let onChange = (e) => {
      e.stopPropagation();
      e.preventDefault();
      let selectedItems = this.state.selectedItems;
      selectedItems[key] = !selectedItems[key];
      this.setState({ selectedItems: selectedItems });
      if (this.props.settings.onSelect) this.props.settings.onSelect(key);
    };
    return (
      <label className="checkbox" onClick={(e) => onChange(e)}>
        <input
          type="checkbox"
          onChange={() => {}}
          checked={this.state.selectedItems && this.state.selectedItems[key]}
        />
        <span></span>
      </label>
    );
  }

  deleteRow(e) {
    e.preventDefault();
    e.stopPropagation();
    return true;
  }

  copyRow(e) {
    e.preventDefault();
    e.stopPropagation();
    return true;
  }

  render() {
    return (
      <>
        <div className="actions clearfix">
          <div className="filters clearfix">
            {this.props.settings.filters.map((action, i) => {
              if (action.type === "select") {
                return (
                  <div key={`field-${i}`} className="search select">
                    <Select
                      isMulti={action?.isMulti ?? false}
                      placeholder={action?.placeholder}
                      isClearable={action?.isClearable || false}
                      value={action.value}
                      onChange={action.onChange}
                      options={action.entities}
                      getOptionLabel={(entity) => entity.name}
                      getOptionValue={(entity) => entity.id}
                      components={{
                        Option: action?.isMulti
                          ? CustomizedCheckboxOption
                          : CustomizedOption,
                        IndicatorSeparator: null,
                        DropdownIndicator: (state) => {
                          const { selectProps } = state;
                          return (
                            <div className="default-selector__indicator">
                              <i
                                className={`icon-carot-${
                                  selectProps?.menuIsOpen ? "up" : "down"
                                } ${
                                  selectProps?.menuIsOpen ? "menu-opened" : ""
                                }`}
                              />
                            </div>
                          );
                        },
                      }}
                    />
                  </div>
                );
              } else
                return (
                  <div key={`field-${i}`} className="search icon-bigsearch">
                    <input
                      type="text"
                      placeholder={action.label}
                      onChange={(e) => action.onChange(e.target.value)}
                    />
                  </div>
                );
            })}
          </div>

          <div className="buttons clearfix">
            {this.props.settings.actions.map((action, i) => {
              return (
                <button
                  key={`button-${i}`}
                  className={action.classList}
                  onClick={action.onClick}
                >
                  {action.label}
                </button>
              );
            })}
          </div>
        </div>

        <div className="table-wrapper">
          {this.props.settings.entities && (
            <table>
              <thead>
                <tr key="header">
                  {this.props.settings.columns.map((column, key) => !column.hidden && (
                    <ColumnHead
                      key={column.key + key}
                      idx={key}
                      column={column}
                      sort={this.props.sort}
                    />
                  ))}
                </tr>
              </thead>

              <tbody>
                {this.props.settings.entities.map((entity, rowKey) => {
                  return (
                    <tr
                      key={entity.id}
                      onClick={() =>
                        this.props.settings.onRowClick &&
                        this.props.settings.onRowClick(entity)
                      }
                    >
                      {this.props.settings.columns?.map((column, key) => !column.hidden && (
                        <ColumnBody
                          key={rowKey + "" + key}
                          idx={key}
                          column={column}
                          rowKey={rowKey}
                          entity={entity}
                          makeCheckbox={this.makeCheckbox}
                          deleteRow={this.deleteRow}
                          copyRow={this.copyRow}
                          multiSelect={this.props.settings.multiSelect}
                        />
                      ))}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
          {(!this.props.settings.entities ||
            !this.props.settings.entities.length) && (
            <div className="empty">There is no content in this list</div>
          )}
        </div>
      </>
    );
  }
}

export default Table;

function ColumnBody(props) {
  const {
    column,
    entity,
    rowKey,
    idx,
    deleteRow,
    copyRow,
    makeCheckbox,
    multiSelect,
  } = props;
  if (!column) return;
  if (column?.action === "delete")
    return (
      <td key={entity.id + "delete"}>
        <i
          className="icon-trash"
          onClick={(e) =>
            deleteRow(e, entity.id, rowKey) &&
            column.onClick &&
            column.onClick(entity.id, rowKey, entity)
          }
        ></i>
      </td>
    );
  else if (column?.action === "copy")
    return (
      <td
        className={column?.className ? column.className : ""}
        key={entity.id + "copy"}
      >
        <i
          className="icon-copy"
          onClick={(e) =>
            copyRow(e, entity.id, rowKey) &&
            column.onClick &&
            column.onClick(entity.id, rowKey, entity)
          }
        ></i>
      </td>
    );
  else
    return (
      <td
        width={column?.width ?? "auto"}
        className={column?.className ? column.className : ""}
        key={entity.id + idx}
      >
        {multiSelect && idx === 0 && makeCheckbox(rowKey)}{" "}
        {column.view
          ? column.view(entity[column.key], entity)
          : entity[column.key]}
      </td>
    );
}

function ColumnHead(props) {
  const { sort, column, idx } = props;
  const sorted = sort?.[0] === column?.key;
  const order = sort?.[1]?.toString()?.toLowerCase();

  if (!column) {
    return;
  }

  if (column?.action) {
    return <td width={30} key={idx}></td>;
  }

  return (
    <td key={idx}>
      <div
        onClick={() => {
          if (column?.onSortClick && typeof column.onSortClick === "function") {
            column.onSortClick(column);
          }
        }}
        width={column?.width ?? "auto"}
        className={`
          ${column.canSort ? "sort-icon" : ""} 
          ${sorted ? "sorted" : ""}
          `}
      >
        <div className="line">{column.label}</div>
        {column.canSort && (
          <div>
            <i
              className={`${
                order && sorted
                  ? "icon-sort-arrow-" + order
                  : "icon-sort-arrow-desc"
              }`}
            />
          </div>
        )}
      </div>
    </td>
  );
}
